export { default as EthanZuckerman } from './Ethan_Zuckerman.jpg'
export { default as AnasuyaSengupta } from './Anasuya_Sengupta.jpg'



// WEBPACK FOOTER //
// ./src/assets/LandingPage/keynotes/avatar/index.js